import styled from 'styled-components';
import { contiOrange } from '../../../style/colors';
import { PageDescription } from './Layout.style';

export const FileUploadZone = styled.div`
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  background: #f9fafb;
  transition: all 0.2s;
  cursor: pointer;
  margin-bottom: 20px;

  ${(props) =>
    props.$isDragActive &&
    `
    border-color: ${contiOrange};
    background: #fff7ed;
  `}

  ${(props) =>
    props.$hasFile &&
    `
    border-color: ${contiOrange};
    background: #fff7ed;
  `}

  &:hover {
    border-color: ${contiOrange};
    background: #fffbf5;
  }

  i {
    font-size: 48px;
    color: ${contiOrange};
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    color: #6b7280;
    margin: 8px 0 0 0;
  }

  strong {
    color: #111827;
    display: block;
    margin-bottom: 4px;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const PreviewTable = styled.div`
  max-height: 300px;
  overflow: auto;
  margin-bottom: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
`;

export const PreviewNote = styled(PageDescription)`
  text-align: center;
  margin-top: 8px;
`;

